<div class="relative w-full ">
    @if (label()) {
      <label  class="block text-sm font-medium leading-6 text-[#212121] relative">
        {{ label() }}
        @if(isRequired()){
          <span class="absolute text-[#D92D20] font-medium text-sm ml-[2px] mt-[1px]">*</span>
        }

      </label>
    }
    <div (click)="isDropdownOpen.set(!isDropdownOpen())" class="relative">
      <button 
        type="button"

        [ngClass]="isDropdownOpen() ?'border-[2px] border-[#0e73a9]':'border border-[#DEDEDE]' "
        class="h-[38px]  text-left mt-2 mb-1 flex items-center justify-between text-[#212121] cursor-pointer w-full px-3 py-2  sm:text-sm  rounded-md"
        placeholder="Select job nature">
        {{ selectedItem() ? (activeLang() === 'en' ?  selectedItem()!.en: selectedItem()!.bn ) : placeholder() }}
        <span class="icon-angle-bottom transform  text-primary-500 "></span>
        <img 
            [class.rotate-180] = "!isDropdownOpen()"
            [src]="environment.homeImageUrl + 'arrow-down.svg'" alt="arrow.svg" class="absolute top-2 right-2"
        >

      </button>
    </div>

    @if (isDropdownOpen()) {
      <div 
        [class.top-[72px]]="label()"
        class="w-full !mt-1.5 bg-white top-[40px] dropdown-shadow rounded-md border border-[#DAE5EC] px-2 py-2">
        <div class="max-h-[140px] overflow-y-auto">
          @for (item of options(); track item.value) {
            <div 
              class="flex items-center hover:bg-[#F3F4F6] hover:rounded-md cursor-pointer transition-all duration-200 ease-in-out px-2 py-1"
              (click)="selectItem(item)"
            >
              <input 
                [id]="item.selectId"
                type="radio"
                class="hidden"
                [name]="name()"
                [value]="item.value"
                [checked]="control().value === item.value"
              >
              <label class="text-sm text-[#212121] cursor-pointer w-full">
                {{ activeLang()==='en' ? item.en : item.bn }}
              </label>
            </div>
          }
        </div>

      </div>
    }
  </div>
